<template>
    <div id="login">
        <form class="login-member-form">
            <div class="info">
                <img class="icon" src="../assets/login_username_input_icon.png" alt="">
                <input class="input" type="text" name="memberNumber" placeholder="会员名/会员编号/手机号"
                       v-model="loginForm.memberInfo">
            </div>

            <div class="info" style="margin-top: 20px">
                <img class="icon" src="../assets/login_password_input_icon.png" alt="">
                <input class="input" type="password" name="memberNumber" placeholder="密码"
                       v-model="loginForm.password">
            </div>
        </form>

        <div class="rember" v-show="loginForm.rememberPassword">
            记住密码可能会使密码泄露
        </div>

        <div style="text-align: left; margin-left: 30px; margin-top: 15px; font-size: 1rem">
            <span class="input-box-off" :class="{'on': show}"></span>
            <input class="input-box" type="checkbox" v-model="loginForm.rememberPassword" @change="changeBox">
            <span style="height: 25px;line-height: 25px">记住密码</span>
        </div>

        <div class="login-member-forget-password" @click="memberForgetPassword">
            忘记密码？找回密码
        </div>

        <div class="login-member-login">
            <button class="login-member-login-btn" @click="memberLoginSubmit" :disabled="btnDisable">登录</button>
        </div>

        <div class="login-member-register" @click="memberRegister">
            注册
        </div>

        <div class="login-member-login">
            <!--            <button class="login-member-login-btn" @click="memberQuickLoginSubmit" :disabled="btnDisable">快速登录</button>-->
            <div style="margin-top: 3vh">——其他登录/注册方式——</div>
            <img src="../assets/wechat_icon.png" style="width: 80%;margin-top: 3vh" @click="memberQuickLoginSubmit">

        </div>

        <!--        <div class="login-member-register" @click="weChatMemberRegister">-->
        <!--            快速注册-->
        <!--        </div>-->

        <base-dialog v-show="messageVisible" :title="title" width="80%" @close="close">
            <p>{{ message }}</p>
        </base-dialog>

        <div class="toast" v-show="toastShow">
            {{toastText}}
        </div>
    </div>
</template>

<script>
import BaseDialog from "../components/BaseDialog";
import {SystemContent, SystemStatus} from "@/api/Login";
// import {WX_CODE} from "@/config/app";
    // import {WeChatUserInfo} from "@/api/Login";
    export default {
        name: "Login",
        components: {
            BaseDialog
        },
        data() {
            return {
                loginForm: {
                    memberInfo: '',
                    password: '',
                    rememberPassword: false,
                    openId: '',
                    unionId: ''
                },
                // unionId: '',
                toastShow: false,
                toastText: '',

                title: '提示',
                messageVisible: false,
                message: "",

                show: false,

                btnDisable: false,
            }
        },

        created() {
            //系统维护
            SystemContent()
                .then(res => {
                    localStorage.setItem('maintenance', res.data.value);
                });

            SystemStatus()
                .then();


            // let openId = this.$cookies.get('openid');
            // let unionId = this.$cookies.get('unionid');
            // if (openId == null || openId === '') {
            //     let local = window.location.href; // 获取页面url
            //     let appid = WX_CODE;
            //     let code = this.GetUrlParame('code'); // 截取code
            //     if (code == null || code === '') { // 如果没有code，则去请求
            //         window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
            //         return;
            //     } else {
            //         WeChatUserInfo(code)//如果有code，说明用户点击了授权  将获取到的code传递给后台
            //             .then(res => {
            //                 // 返回状态和UId
            //                 if (res.data.openId) {
            //                     this.$cookies.set("openid", res.data.openId);
            //                     this.$cookies.set("unionid", res.data.unionId);
            //                     // openId = res.data.openId;
            //                     // unionId = res.data.unionId;
            //                 }
            //             });
            //     }
            // }

            let account = this.$cookies.get("account");
            let password = this.$cookies.get("password");

            if (account !== null && password !== null) {
                this.loginForm.memberInfo = account;
                this.loginForm.password = password;
                this.loginForm.rememberPassword = true;
                this.show = true;

            }

            localStorage.setItem("addressId", "");
            localStorage.setItem("username", "");
            localStorage.setItem("userAddress", "");
            localStorage.setItem("userPhone", "");

        },

        methods: {
            // 截取code
            GetUrlParame(parameName) {
                /// 获取地址栏指定参数的值
                /// <param name="parameName">参数名</param>
                // 获取url中跟在问号后面的部分
                let parames = window.location.search;
                // 检测参数是否存在
                if (parames.indexOf(parameName) > -1) {
                    let parameValue = '';
                    parameValue = parames.substring(parames.indexOf(parameName), parames.length);
                    // 检测后面是否还有参数
                    if (parameValue.indexOf('&') > -1) {
                        // 去除后面多余的参数, 得到最终 parameName=parameValue 形式的值
                        parameValue = parameValue.substring(0, parameValue.indexOf('&'));
                        // 去掉参数名, 得到最终纯值字符串
                        parameValue = parameValue.replace(parameName + '=', '');
                        return parameValue;
                    }
                    return '';
                }
            },


            memberForgetPassword() {
                this.$router.push({path: '/forgetPassword'})
            },

            close() {
                this.messageVisible = false;
                this.$emit('close');
            },

            toast(e) {
                let _that = this;
                this.toastText = e;
                this.toastShow = true;
                setTimeout(function () {
                    _that.toastShow = false
                }, 1500)
            },

            memberLoginSubmit() {
                if (this.loginForm.memberInfo === '') {
                    this.toast("请输入账号");
                    return
                }

                if (this.loginForm.password === '') {
                    this.toast("请输入密码");
                    return
                }
                this.btnDisable = true;
                let openId = this.$cookies.get('openid');
                let unionId = this.$cookies.get('unionid');
                this.loginForm.openId = openId;
                this.loginForm.unionId = unionId;
                this.$store.dispatch('Login', this.loginForm)
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            this.$router.push({path: '/home'});
                            this.saveAccountInfoToCookie();
                        }
                        this.btnDisable = false;
                    }).catch(error => {
                    this.message = error.message;
                    this.messageVisible = true;
                    this.btnDisable = false;
                })
            },

            memberQuickLoginSubmit() {
                this.btnDisable = true;
                let openId = this.$cookies.get('openid');
                let unionId = this.$cookies.get('unionid');
                if ((openId == null || openId === '') && (unionId == null || unionId === '')) {
                    this.$router.push({path: '/weChatRegisterMember'});
                    return;
                }

                let members = {
                    unionId: unionId,
                    openId: openId
                };
                this.$store.dispatch('QuickLogin', members)
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            this.$router.push({path: '/home'});
                        }
                        this.btnDisable = false;
                    }).catch(error => {
                    this.$router.push({path: '/weChatRegisterMember'});
                    console.log(error.message);
                    // this.message = error.message;
                    // this.messageVisible = true;
                    // this.btnDisable = false;
                })
            },

            //储存标签信息
            saveAccountInfoToCookie() {
                if (this.loginForm.rememberPassword) {
                    this.$cookies.set("account", this.loginForm.memberInfo);
                    this.$cookies.set("password", this.loginForm.password);
                    this.$cookies.set("remember", this.loginForm.rememberPassword);
                } else {
                    this.$cookies.set("account", "");
                    this.$cookies.set("password", "");
                }
            },
            memberRegister() {
                this.$router.push({path: '/registerMemberFirst'})
            },

            weChatMemberRegister() {

            },

            changeBox() {
                if (this.show) {
                    this.show = false;
                } else {
                    this.show = true;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    #login {
        background-color: #f8e7e9;
        width: 100%;
        height: 100%;
        padding-top: 60px;
        padding-bottom: 60px;
        position: absolute;

        .rember {
            color: #ed3f14;
            font-size: 1rem;
            text-align: center;
            margin: .5rem;
        }
    }

    .login-member-form {
        margin-left: 30px;
        margin-right: 30px;
        margin-top: 60px;

        .info {
            background: #FFFFFF;
            width: 100%;
            height: 3rem;
            border-radius: 5px;
            border: 2px solid #ed3f14;
            display: flex;
            align-items: center;

            .input {
                width: 80%;
                height: 2.5rem;
                border: 0;
                outline: none;
                margin-left: 20px;
                font-size: 1.1rem;
            }

            .icon {
                width: 20px;
                height: 20px;
                float: left;
                margin-left: 15px;
            }
        }
    }

    .login-member-forget-password {
        margin-top: 30px;
        font-size: 1rem;
    }

    .input-box {
        display: inline-block;
        position: absolute;
        opacity: 0;
        width: 20%;
        height: 25px;
        cursor: pointer;
        left: 30px;
        outline: none;
        -webkit-appearance: none;
    }

    .input-box-off {
        width: 25px;
        height: 25px;
        vertical-align: middle;
        float: left;
        background-image: url(../assets/check_box_outline_blank.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }

    .on {
        background-image: url(../assets/check_box_24px_rounded.png);
        background-size: 100% 100%;
    }

    .login-member-login-btn {
        width: 100%;
        height: 2.5rem;
        margin-top: 10px;
        border: 0;
        border-radius: 5px;
        background-color: #ed3f14;
        color: white;
        font-size: 1rem;
    }

    .login-member-login {
        margin-top: 3vh;
        margin-left: 30px;
        margin-right: 30px;
    }

    .login-member-register {
        margin-top: 30px;
        font-size: 1rem;
        color: #ed3f14;
    }
</style>